import { render, staticRenderFns } from "./SearchSoundTagsFilter.vue?vue&type=template&id=502f8146&scoped=true"
import script from "./SearchSoundTagsFilter.vue?vue&type=script&lang=js"
export * from "./SearchSoundTagsFilter.vue?vue&type=script&lang=js"
import style0 from "./SearchSoundTagsFilter.vue?vue&type=style&index=0&id=502f8146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f8146",
  null
  
)

export default component.exports